import { useAuthentication } from '@/plugins/authenticationMSEntra'

export async function checkThatUserIsLoggedIn() {
  const { login, handleRedirect, state } = useAuthentication()

  await handleRedirect()
  if (state.isAuthenticated) {
    window.hideImage()
    return true
  }
  await login()
  return false
}